const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'whitebox',
  tiles: {
    door: 0,
    door_locked: 1,
    door_unlocked: 2,
    down: 3,
    pillar1: 4,
    pillar2: 5,
    pillar3: 6,
    pillar4: 7,
    pit_closed: 8,
    pit_open: 9,
    secret: 10,
    solid: 11,
    up: 12
  },
  uidata: {
    rects: [
      vec4(8/1024,8/512,136/1024,136/512),
      vec4(152/1024,8/512,280/1024,136/512),
      vec4(296/1024,8/512,424/1024,136/512),
      vec4(440/1024,8/512,568/1024,136/512),
      vec4(584/1024,8/512,712/1024,136/512),
      vec4(728/1024,8/512,856/1024,136/512),
      vec4(872/1024,8/512,1000/1024,136/512),
      vec4(8/1024,152/512,136/1024,280/512),
      vec4(152/1024,152/512,280/1024,280/512),
      vec4(296/1024,152/512,424/1024,280/512),
      vec4(440/1024,152/512,568/1024,280/512),
      vec4(584/1024,152/512,712/1024,280/512),
      vec4(728/1024,152/512,856/1024,280/512)
    ]
  },
  FRAME_DOOR: 0,
  FRAME_DOOR_LOCKED: 1,
  FRAME_DOOR_UNLOCKED: 2,
  FRAME_DOWN: 3,
  FRAME_PILLAR1: 4,
  FRAME_PILLAR2: 5,
  FRAME_PILLAR3: 6,
  FRAME_PILLAR4: 7,
  FRAME_PIT_CLOSED: 8,
  FRAME_PIT_OPEN: 9,
  FRAME_SECRET: 10,
  FRAME_SOLID: 11,
  FRAME_UP: 12
};
spritesheetRegister(module.exports);
